import { Environment as Env } from './develop.environment';

export class Environment extends Env {
  static override readonly urlAPI: string = 'https://aws-dev-wag-api-am3.azurewebsites.net/';
}
